import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { MitsIconComponent } from './mits-icon.component';

@NgModule({
  imports: [CommonModule, IonicModule, FormsModule],
  declarations: [MitsIconComponent],
  entryComponents: [MitsIconComponent],
  exports: [MitsIconComponent],
  providers: [],
})
export class MitsIconModule {}
